import React from "react";
import { Check, IdCard, RefreshCw, Wallet, FileText, Download } from "lucide-react";
import { Button } from "./ui/button";
import { TESSERAMENTO, CONTACT } from "../data/mock";

const BLOCK_ICONS = [Wallet, IdCard, RefreshCw];

export default function Tesseramento() {
  return (
    <section id="tesseramento" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 reveal">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
              Iscriviti
            </div>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
              {TESSERAMENTO.title}
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">{TESSERAMENTO.intro}</p>

            <div className="mt-7 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Quota annuale</div>
              <div className="mt-1 flex items-baseline gap-1">
                <span className="text-4xl font-extrabold text-[#0a1f55]">€ 50</span>
                <span className="text-sm text-slate-500">,00 / anno</span>
              </div>
              <div className="mt-1 text-[13px] text-slate-500">Validità 365 giorni dalla data di iscrizione</div>
              <a href={CONTACT.iscrizione} target="_blank" rel="noreferrer">
                <Button className="mt-5 w-full bg-[#102a6b] hover:bg-[#0a1f55] text-white">
                  Iscriviti ora
                </Button>
              </a>
            </div>

            {/* Statuto download card */}
            <a
              href={CONTACT.statutoPdf}
              target="_blank"
              rel="noreferrer"
              download
              className="mt-4 group block rounded-2xl border border-slate-200 bg-white hover:border-[#102a6b]/40 p-5 shadow-sm transition-all lift"
            >
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-xl bg-[#f59e0b]/15 text-[#b45309] flex items-center justify-center shrink-0">
                  <FileText className="h-6 w-6" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
                    Documento ufficiale
                  </div>
                  <div className="text-[15px] font-extrabold text-[#0a1f55] leading-tight">
                    Atto e Statuto A.C.D.T.
                  </div>
                  <div className="text-[12px] text-slate-500 mt-0.5">PDF • Scarica per consultare</div>
                </div>
                <div className="h-9 w-9 rounded-lg bg-[#102a6b] text-white flex items-center justify-center group-hover:bg-[#0a1f55] transition-colors shrink-0">
                  <Download className="h-4 w-4" />
                </div>
              </div>
            </a>
          </div>

          <div className="lg:col-span-8 grid md:grid-cols-3 gap-5">
            {TESSERAMENTO.blocks.map((b, i) => {
              const Icon = BLOCK_ICONS[i] || Wallet;
              return (
                <div
                  key={b.heading}
                  className="reveal rounded-2xl border border-slate-200 bg-white p-6 lift"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="h-10 w-10 rounded-lg bg-[#f59e0b]/15 text-[#b45309] flex items-center justify-center">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-[#0a1f55]">{b.heading}</h3>
                  {b.price && (
                    <div className="mt-1 text-2xl font-extrabold text-[#102a6b]">{b.price}</div>
                  )}
                  <p className="mt-2 text-[13.5px] text-slate-600 leading-relaxed">{b.subheading}</p>
                  <ul className="mt-4 space-y-2.5">
                    {b.items.map((it) => (
                      <li key={it} className="flex items-start gap-2 text-[13.5px] text-slate-700">
                        <Check className="h-4 w-4 mt-0.5 text-[#102a6b] shrink-0" />
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
